<template>
    <div id="app">
    	<router-view/>
    	<AppMenu/>
    </div>
</template>

<script>
	import AppMenu from './components/AppMenu.vue'

	export default {
		name: 'app',
		components: {
			AppMenu
		},
		data: function() {
			return {
			}
		},
    	methods: {
    		
    	}
	}
</script>

<style lang="less">
@green_medium: #66DCAC;

html, body {
	height: 100%;
	margin: 0;
}
#app {
	height: 100%;
	width: 100%;
}

button:active,
button:focus {
    outline: none;
}

.page-header {
	margin-top: 15px;
	font-family: Roboto;
	font-weight: 900;
	font-size: 22px;
	line-height: 100%;
	color: @green_medium;
}

.page {
	height: calc(100% - 59px);
	display: flex;
	flex-direction: column;
	align-items: center;
}
</style>